import { render, staticRenderFns } from "./dict-form.vue?vue&type=template&id=a5d3c1a2&"
import script from "./dict-form.vue?vue&type=script&lang=ts&"
export * from "./dict-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports